import { cn } from "@/lib/utils";

export const Container = ({
  className,
  children,
  asGrid = false,
  id,
  props,
  overflow = "hidden",
}: {
  className?: string;
  children: React.ReactNode;
  asGrid?: boolean;
  id?: string;
  props?: React.HTMLAttributes<HTMLDivElement>;
  overflow?: "hidden" | "visible";
}) => {
  return (
    <div
      {...props}
      id={id}
      className={cn(
        "@container grid grid-cols-[auto_minmax(0,1fr)_auto] xl:grid-cols-[1fr_auto_1fr]",
        overflow === "hidden" ? "overflow-hidden" : "overflow-visible",
      )}
    >
      <Decorator />
      <div
        className={cn(
          "max-w-276 xl:min-w-276 mx-auto w-full min-w-0",
          !asGrid && "p-[0.5px]",
        )}
      >
        {asGrid ? (
          <div
            className={cn(
              "**:data-grid-content:bg-card/75 **:data-grid-content:h-full **:data-grid-content:rounded grid *:p-[0.5px]",
              className,
            )}
          >
            {children}
          </div>
        ) : (
          <div
            data-slot="content"
            className={cn("bg-card/75 h-full rounded", className)}
          >
            {children}
          </div>
        )}
      </div>
      <Decorator />
    </div>
  );
};

export const Separator = ({ className }: { className?: string }) => {
  return (
    <Container aria-hidden>
      <div className={cn("h-16", className)} />
    </Container>
  );
};

const Decorator = ({ className }: { className?: string }) => {
  return (
    <div aria-hidden className={cn("p-[0.5px]", className)}>
      <div className="bg-card/75 h-full w-2 rounded lg:w-12 xl:w-full" />
    </div>
  );
};
